<template>
  <path
    d="M8.353 3.646a.5.5 0 0 0-.764.638l.058.07L15.297 12l-7.65 7.646a.5.5 0 0 0-.058.638l.057.07a.5.5 0 0 0 .638.057l.07-.057 8.004-8a.5.5 0 0 0 .057-.638l-.057-.07-8.005-8z"
    fill="#010A0D"
    fill-rule="nonzero"
  />
</template>
